module.exports = __webpack_public_path__ + "img/dealOrNoDeal.c12fb1f5.webp";